import { Button, ButtonProps, Intent } from '@blueprintjs/core';
import { useAppDispatch } from '../../hooks';
import { nextStep } from '../../views/workflow/reducer';

const NextButton = (props: ButtonProps) => {
  const dispatch = useAppDispatch();

  return (
    <Button
      {...props}
      rightIcon="chevron-right"
      intent={Intent.PRIMARY}
      fill
      onClick={() => dispatch(nextStep())}
    >
      Próximo
    </Button>
  );
};

export default NextButton;
